<template>
  <div>{{ +value }}</div>
</template>

<script>
export default {
  data() {
    return {
      value: null
    };
  },

  filters: {
    number(value) {
      return value.toFixed(2);
    }
  },

  mounted() {
    this.value = this.params.value;
  }
};
</script>
